import React, { useEffect, useRef } from "react";

interface FooterProps {
  id?: string;
}

const Footer: React.FC<FooterProps> = ({ id }) => {
  const footerRef = useRef<HTMLElement | null>(null);

  // Prevent horizontal scroll on mount
  useEffect(() => {
    const prevHtmlOverflowX = document.documentElement.style.overflowX;
    const prevBodyOverflowX = document.body.style.overflowX;
    document.documentElement.style.overflowX = "hidden";
    document.body.style.overflowX = "hidden";
    return () => {
      document.documentElement.style.overflowX = prevHtmlOverflowX;
      document.body.style.overflowX = prevBodyOverflowX;
    };
  }, []);

  return (
    <footer ref={footerRef} style={styles.footer} id={id}>
      {/* Disclaimer Popup */}
      <div style={styles.popup}>
        <div style={styles.popupText}>
          <strong>Disclaimer:</strong> The Goals Optimization Engine (GOE) APIs
          & SDKs site is provided for use by GOE's existing and prospective
          clients (“clients”), offering a comprehensive understanding of the
          APIs used for our services. Please be advised that the data,
          portfolios, and information provided for demonstration purposes to
          prospective clients are strictly hypothetical and intended solely for
          informational use within this demo. These hypothetical outputs should
          not be utilized for actual investment decisions. Comprehensive testing
          and validation of all APIs will be conducted for active GOE clients
          prior to their deployment in production.
        </div>
      </div>

      {/* Footer Bar */}
      <div style={styles.footerBar}>
        <div style={styles.left}>
          © 2026 Franklin Templeton. All Rights Reserved.
        </div>
        <div style={styles.right}>
          <FooterLink
            label="Privacy Notice"
            href="https://www.franklintempletonglobal.com/privacy"
            external
          />
        </div>
      </div>
    </footer>
  );
};

const FooterLink: React.FC<{
  label: string;
  href?: string;
  onClick?: () => void;
  external?: boolean;
}> = ({ label, href = "#", onClick, external }) => (
  <a
    href={href}
    style={styles.link}
    aria-label={label}
    onClick={(e) => {
      if (onClick) {
        e.preventDefault();
        onClick();
      }
    }}
    target={external ? "_blank" : undefined}
    rel={external ? "noopener noreferrer" : undefined}
  >
    {label}
  </a>
);

const styles: { [key: string]: React.CSSProperties } = {
  footer: {
    position: "fixed",
    flexShrink: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    zIndex: 1000,
    boxSizing: "border-box",
    
  },
  popup: {
    backgroundColor: "#fff",
    color: "#000",
    padding: "8px 12px",
    fontSize: "9px",
    borderTop: "2px solid #3469ff",
    boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "8px",
    boxSizing: "border-box",
    maxWidth: "100%",
  },
  popupText: {
    flex: 1,
    lineHeight: "1.4",
    minWidth: 0,
  },
  footerBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 12px",
    backgroundColor: "rgb(52, 105, 255)",
    color: "white",
    fontSize: "12px",
    minHeight: "40px",
    boxSizing: "border-box",
  },
  left: {
    flex: 1,
    minWidth: 0,
  },
  right: {
    display: "flex",
    gap: "15px",
    flexWrap: "wrap",
  },
  link: {
    textDecoration: "underline",
    color: "white",
    cursor: "pointer",
    wordBreak: "break-word",
  },
};

export default Footer;
